import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["value", "reloadLink", "countdownBox"];
  static values = { start: { type: Number, default: 90 } };

  connect() {
    this.current = this.startValue;
    this.valueTarget.textContent = this.current;

    this.timer = setInterval(() => {
      this.current -= 1;
      if (this.current <= 0) {
        this.current = 0;
        this.valueTarget.textContent = this.current;
        clearInterval(this.timer);
        this.showReloadLink();
      } else {
        this.valueTarget.textContent = this.current;
      }
    }, 1000);
  }

  disconnect() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }

  showReloadLink() {
    this.countdownBoxTarget.style.display = "none";
    this.reloadLinkTarget.style.display = "";
  }
}
